import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getRecommendedServiceProviders } from "../services/serviceProviders";
import { IRecommendedServiceProvider } from "../types/recommendations.types";

export const RECOMMENDED_SERVICE_PROVIDERS_QUERY_KEY =
  "recommendedServiceProviders";

interface IUseRecommendedServiceProvidersResult {
  serviceProviders: IRecommendedServiceProvider[] | undefined;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
}

export const useRecommendedServiceProviders =
  (): IUseRecommendedServiceProvidersResult => {
    const { data, isLoading, isError, isSuccess } = useDataQuery(
      [RECOMMENDED_SERVICE_PROVIDERS_QUERY_KEY],
      () => getRecommendedServiceProviders().then(({ data }) => data),
      { staleTime: 10 * 60 * 1000 } // 10min
    );

    return {
      serviceProviders: data?.data.service_providers,
      isLoading,
      isError,
      isSuccess,
    };
  };
